import React from "react";
import { injectIntl } from "react-intl";
import "./my-ebsco-data-privacy.scss";

const DataPrivacyContent = ({
  intl: { formatMessage },
  className,
  privacyHeading,
  privacyBody
}) => {
  return (
    <>
      <h3 className={className}>{formatMessage(privacyHeading)}</h3>
      <span>{formatMessage(privacyBody)}</span>
    </>
  );
};

export { DataPrivacyContent };
export default injectIntl(DataPrivacyContent);
